import React, { useState } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import SunEditor from 'suneditor-react'
import 'suneditor/dist/css/suneditor.min.css'
import { mediaImageUploadAction } from 'src/reducers/media-image/action'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import { useDispatch, useSelector } from 'react-redux'
import { patchSetting } from 'src/hooks/useCardSettings'
import { editorLoading } from 'src/reducers/card/action'

const Accordion = withStyles({
  root: {
    width: '100%',
    boxShadow: 'none',
    borderRadius: '8px',
    backgroundColor: '#fff',

    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
      boxShadow: 'none',
      backgroundColor: '#fff',
    },
  },
  expanded: {
    backgroundColor: '#fff',
  },
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: '#fff',
    minHeight: 46,
    borderRadius: '8px',
    padding: '0 12px',
    '&$expanded': {
      minHeight: 46,
      backgroundColor: '#fff',
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
})(MuiAccordionSummary)

const AccordionDetails = withStyles(theme => ({
  root: {
    backgroundColor: '#fff',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    borderRadius: '8px',
  },
}))(MuiAccordionDetails)

const AccordionPart = props => {
  const { classes, settings, badgeSettings, badgeUsageType } = props
  const dispatch = useDispatch()
  const editorLoadingState = useSelector(state => state.card.editorLoading)

  const [completionMessage, setCompletionMessage] = useState(
    badgeSettings.completionMessage,
  )
  const [successMessage, setSuccessMessage] = useState(
    badgeSettings.additionalMessageOnSuccess,
  )

  const [failMessage, setFailMessage] = useState(
    badgeSettings.additionalMessageOnFail,
  )

  const handleSuccessMessage = e => {
    dispatch(editorLoading())
    setSuccessMessage(e)
    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({
        ...badgeSettings,
        additionalMessageOnSuccess: e,
      }),
      () => {
        setTimeout(() => {
          dispatch(editorLoading())
        }, 3000)
      },
    )
  }

  const handleCompletionMessage = e => {
    dispatch(editorLoading())
    setCompletionMessage(e)
    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({
        ...badgeSettings,
        completionMessage: e,
      }),
      () => {
        setTimeout(() => {
          dispatch(editorLoading())
        }, 3000)
      },
    )
  }

  const handleFailMessage = e => {
    dispatch(editorLoading())
    patchSetting(
      dispatch,
      settings.cardId,
      settings.id,
      'badge',
      JSON.stringify({
        ...badgeSettings,
        additionalMessageOnFail: e,
      }),
      () => {
        setTimeout(() => {
          dispatch(editorLoading())
        }, 3000)
      },
    )
  }

  // Add new handler functions for onBlur events
  const handleSuccessMessageBlur = (event, editorContents) => {
    if (editorLoadingState) {
      setTimeout(() => {
        handleSuccessMessage(editorContents)
      }, 2000)
    } else {
      handleSuccessMessage(editorContents)
    }
  }

  const handleCompletionMessageBlur = (event, editorContents) => {
    if (editorLoadingState) {
      setTimeout(() => {
        handleCompletionMessage(editorContents)
      }, 2000)
    } else {
      handleCompletionMessage(editorContents)
    }
  }

  const handleFailMessageBlur = (event, editorContents) => {
    if (editorLoadingState) {
      setTimeout(() => {
        handleFailMessage(editorContents)
      }, 2000)
    } else {
      handleFailMessage(editorContents)
    }
  }

  const [expandedBool, setExpandedBool] = React.useState('')

  const handleChange = () => {
    expandedBool == 'panel1' ? setExpandedBool('') : setExpandedBool('panel1')
  }

  return (
    <Accordion expanded={expandedBool == 'panel1'}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        onClick={() => handleChange()}
      >
        <Typography className={classes.heading}>Customize Message</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography className={classes.description}>
          {badgeUsageType == 0
            ? 'Message displayed on completion'
            : 'Message displayed on success'}
        </Typography>
        <div style={{ display: badgeUsageType == 0 ? 'flex' : 'none' }}>
          <SunEditor
            key={'completionMessage-editor'}
            value={completionMessage}
            defaultValue={completionMessage}
            onBlur={handleCompletionMessageBlur} // Updated
            className={classes.textArea}
            setDefaultStyle="text-align: center;"
            onImageUploadBefore={(files, info, uploadHandler) => {
              dispatch(
                mediaImageUploadAction(files[0], '', result => {
                  const response = {
                    result: [
                      {
                        url: `${URL.MEDIA}${result.url}`,
                        name: result.name,
                        size: 100,
                      },
                    ],
                  }

                  uploadHandler(response)
                }),
              )
            }}
            setOptions={{
              mode: 'inline',
              formats: ['h1', 'h2', 'p'],
              placeholder:
                'This content will appear under the condition you define.',
              height: 160,

              buttonList: [
                [],
                ['formatBlock'],
                [],
                ['bold'],
                [],
                ['image'],
                [],
                ['codeView'],
                [],
                [
                  ':i-More Misc-default.more_vertical',
                  'fontColor',
                  'hiliteColor',
                  'align',
                  'link',
                  'italic',
                  'underline',
                  'removeFormat',
                ],
              ],
              pasteTagsWhitelist: 'p|h1|h2|h3',
              imageMultipleFile: false,
              imageUrlInput: false,
              imageAlignShow: false,
              imageHeightShow: false,
              imageResizing: false,
              popupDisplay: 'local',
              attributesWhitelist: {
                all:
                  'style|dir|class|width|height|title|allow|allowfullscreen|aspectratio|id|frameborder|iframe|className|data-.+',
              },
            }}
          />
        </div>
        <div
          style={{
            display: badgeUsageType == 1 ? 'flex' : 'none',
          }}
        >
          <SunEditor
            key={'successMessage-editor'}
            value={successMessage}
            defaultValue={successMessage}
            onBlur={handleSuccessMessageBlur} // Updated
            onChange={(event, editorContents) =>
              setSuccessMessage(editorContents)
            }
            className={classes.textArea}
            setDefaultStyle="text-align: center;"
            onImageUploadBefore={(files, info, uploadHandler) => {
              dispatch(
                mediaImageUploadAction(files[0], '', result => {
                  const response = {
                    result: [
                      {
                        url: `${URL.MEDIA}${result.url}`,
                        name: result.name,
                        size: 100,
                      },
                    ],
                  }

                  uploadHandler(response)
                }),
              )
            }}
            setOptions={{
              mode: 'inline',
              formats: ['h1', 'h2', 'p'],
              placeholder:
                'This content will appear under the condition you define.',
              height: 160,
              buttonList: [
                [],
                ['formatBlock'],
                [],
                ['bold'],
                [],
                ['image'],
                [],
                ['codeView'],
                [],
                [
                  ':i-More Misc-default.more_vertical',
                  'fontColor',
                  'hiliteColor',
                  'align',
                  'link',
                  'italic',
                  'underline',
                  'removeFormat',
                ],
              ],
              pasteTagsWhitelist: 'p|h1|h2|h3',
              imageMultipleFile: false,
              imageUrlInput: false,
              imageAlignShow: false,
              imageHeightShow: false,
              imageResizing: false,
              popupDisplay: 'local',
              attributesWhitelist: {
                all:
                  'style|dir|class|width|height|title|allow|allowfullscreen|aspectratio|id|frameborder|iframe|className|data-.+',
              },
            }}
          />
        </div>

        <div
          style={{
            display: badgeUsageType == 0 ? 'none' : 'flex',
            flexDirection: 'column',
            gap: 8,
          }}
        >
          <Typography className={classes.description}>
            Message displayed on lack of success
          </Typography>
          <SunEditor
            key={'editor'}
            defaultValue={failMessage}
            value={failMessage}
            onBlur={handleFailMessageBlur}
            onChange={(event, editorContents) => setFailMessage(editorContents)}
            className={classes.textArea}
            setDefaultStyle="text-align: center;"
            onImageUploadBefore={(files, info, uploadHandler) => {
              dispatch(
                mediaImageUploadAction(files[0], '', result => {
                  const response = {
                    result: [
                      {
                        url: `${URL.MEDIA}${result.url}`,
                        name: result.name,
                        size: 100,
                      },
                    ],
                  }

                  uploadHandler(response)
                }),
              )
            }}
            setOptions={{
              mode: 'inline',
              formats: ['h1', 'h2', 'p'],
              placeholder:
                'This content will appear under the condition you define.',
              height: 160,
              buttonList: [
                [],
                ['formatBlock'],
                [],
                ['bold'],
                [],
                ['image'],
                [],
                ['codeView'],
                [],
                [
                  ':i-More Misc-default.more_vertical',
                  'fontColor',
                  'hiliteColor',
                  'align',
                  'link',
                  'italic',
                  'underline',
                  'removeFormat',
                ],
              ],
              attributesWhitelist: {
                all:
                  'style|dir|class|width|height|title|allow|allowfullscreen|aspectratio|id|frameborder|iframe|className|data-.+',
              },
              pasteTagsWhitelist: 'p|h1|h2|h3',
              imageMultipleFile: false,
              imageUrlInput: false,
              imageAlignShow: false,
              imageHeightShow: false,
              imageResizing: false,
              popupDisplay: 'local',
            }}
          />
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default withStyles(styles)(AccordionPart)
